import script from "./PandoraProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./PandoraProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./PandoraProgressBar.vue?vue&type=style&index=0&id=15835a8c&lang=css"

const __exports__ = script;

export default __exports__